import { Message } from 'rbx'
import React from 'react'

interface TodoNoteProps {
  note: string
}

const VisualTodoNote = (props: TodoNoteProps) => {
  if (process.env.NODE_ENV !== 'development') {
    return null
  }

  return (
    <Message color="danger">
      <Message.Body>{props.note}</Message.Body>
    </Message>
  )
}

export default VisualTodoNote
